import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";

import PaymentStatusPage from "@is/components/PaymentStatusPage";
import Registered from "@is/components/Routes/Registered";
import Unregistered from "@is/components/Routes/Unregistered";
import { PaymentStatus, ROUTES } from "@is/constants";
import ScannerContextLayout from "@is/contexts/ScannerContextLayout";
import BestsellerTenants from "@is/features/BestsellerTenants";
import ConfirmedOrderView from "@is/features/ConfirmedOrderView";
import ContentView from "@is/features/ContentView";
import EntryView from "@is/features/EntryView";
import ForwardBasket from "@is/features/ForwardBasket";
import Registration from "@is/features/Registration";
import WelcomePage from "@is/features/WelcomeView";
import useDeviceStatus from "@is/hooks/useDeviceStatus";
import { useManageApiHeaders } from "@is/hooks/useManageApiHeaders";

function AppRoutes() {
  useDeviceStatus();

  const { setApiHeaders } = useManageApiHeaders();

  useEffect(() => {
    setApiHeaders();
  }, [setApiHeaders]);

  return (
    <Routes>
      <Route
        path={ROUTES.Bestseller}
        element={
          <Unregistered>
            <BestsellerTenants />
          </Unregistered>
        }
      />
      <Route
        path={ROUTES.WelcomeView}
        element={
          <Unregistered>
            <WelcomePage />
          </Unregistered>
        }
      />
      <Route element={<ScannerContextLayout />}>
        <Route
          path={ROUTES.Registration}
          element={
            <Unregistered>
              <Registration />
            </Unregistered>
          }
        />
        <Route
          path={ROUTES.EntryView}
          element={
            <Registered>
              <EntryView />
            </Registered>
          }
        />
        <Route
          path={ROUTES.ContentView}
          element={
            <Registered>
              <ContentView />
            </Registered>
          }
        />
        <Route
          path={ROUTES.ConfirmedOrderView}
          element={
            <Registered>
              <ConfirmedOrderView />
            </Registered>
          }
        />
        <Route
          path={ROUTES.ErrorView}
          element={<PaymentStatusPage paymentStatus={PaymentStatus.Failure} />}
        />
        <Route
          path={ROUTES.ErrorExpiredView}
          element={
            <PaymentStatusPage paymentStatus={PaymentStatus.LinkExpired} />
          }
        />
        <Route path={ROUTES.ForwardBasket} element={<ForwardBasket />} />
        <Route
          path={ROUTES.SuccessView}
          element={<PaymentStatusPage paymentStatus={PaymentStatus.Success} />}
        />
        <Route
          path="*"
          element={
            <Registered navigate>
              <EntryView />
            </Registered>
          }
        />
      </Route>
    </Routes>
  );
}

export default AppRoutes;
